import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth from "/app/src/modules/auth/runtime/middleware/auth.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth,
  manifest_45route_45rule
]
export const namedMiddleware = {}